export default class BroadcastMetricTypes {
    public static None: number = 0;
    public static Team: number = 1;
    public static Player: number = 2;
}